import React, { useState } from 'react';
import { Store } from '../StoresPage/StoresPage';
import { TextInput } from '../../../components/TextInput/TextInput';
import { PrimaryButton, SecondaryButton } from '../../../components/Buttons/Buttons';
import { SettingsPage } from '../../../components/SettingsPage/SettingsPage';
import { SettingCard } from '../../../components/SettingCards/SettingCard/SettingCard';
import { ACCOUNT_MANAGEMENT_STRINGS } from '../AccountManagementStrings';
import './EditStorePage.css';
import { ButtonGroup } from '../../../components/Buttons/ButtonGroup/ButtonGroup';
import { SettingCardContent } from '../../../components/SettingCards/SettingCard/SettingCardContent/SettingCardContent';

export interface EditStorePageProps {
	store: Store;
	onBack: () => void;
	onSave?: (updated: Store) => void;
}

export const EditStorePage: React.FC<EditStorePageProps> = ({
	store,
	onBack,
	onSave,
}) => {
	const [name, setName] = useState(store.name);
	const [description, setDescription] = useState(store.description ?? '');

	const isDirty = name !== store.name || description !== (store.description ?? '');

	const handleSave = () => {
		if (onSave) {
			onSave({ ...store, name, description });
		}
		onBack();
	};

	return (
		<SettingsPage
			title={ACCOUNT_MANAGEMENT_STRINGS.editStoreTitle}
			canNavigateBack
			onNavigatingBack={onBack}
			settings={
				<SettingCard
					title=""
					settingId="edit-store"
					description=""
					className="edit-store-card"
					content={
						<SettingCardContent className="edit-store-form">
							<div className="edit-store-fields">
								{/* Store name */}
								<TextInput
									id="edit-store-name"
									label={ACCOUNT_MANAGEMENT_STRINGS.editStoreNameLabel}
									value={name}
									onChange={setName}
									className="edit-store-field--sm"
								/>

								{/* Store URL (readonly) */}
								<TextInput
									id="edit-store-url"
									label={ACCOUNT_MANAGEMENT_STRINGS.editStoreUrlLabel}
									value={store.url}
									onChange={() => undefined}
									disabled
									className="edit-store-field--lg"
								/>

								{/* Description */}
								<TextInput
									id="edit-store-description"
									label={ACCOUNT_MANAGEMENT_STRINGS.editStoreDescriptionLabel}
									value={description}
									onChange={setDescription}
									className="edit-store-field--lg"
								/>
							</div>

							{/* Actions */}
							<ButtonGroup className="edit-store-actions">
								<PrimaryButton onClick={handleSave} disabled={!isDirty}>
									{ACCOUNT_MANAGEMENT_STRINGS.editStoreSaveButton}
								</PrimaryButton>
								<SecondaryButton onClick={onBack}>
									{ACCOUNT_MANAGEMENT_STRINGS.editStoreCancelButton}
								</SecondaryButton>
							</ButtonGroup>
						</SettingCardContent>
					}
				/>
			}
		/>
	);
};
